import { API } from '@Providers';

interface UpdateMedicalCostAddToReceiptPayload {
  receipt_has_medical_costs: boolean;
}

export default async function (payload: UpdateMedicalCostAddToReceiptPayload) {
  const endpoint = '/api/shelter/cart/update-medical-cost-add-to-receipt';

  return API({ endpoint, method: 'put', payload });
}
